import { NgModule } from '@angular/core';
import { FiAppearanceListViewViewComponent } from './list-view-view/list-view-view.component';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '../../utilities/utilities.module';
import { FiStateSrefModule } from '../../shared/fi-state-proxy/state-sref/state-sref.module';
import { DocumentModule } from '../../document/document.module';
import { MediaBankModule } from '../../media-bank/media-bank.module';
import { UserModule } from '@fi-app/user/user.module';
import { FiAppearanceListViewEditComponent } from './list-view-edit/list-view-edit.component';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatButtonModule } from '@angular/material/button';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatCardModule } from '@angular/material/card';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        FiStateSrefModule,
        DocumentModule,
        MediaBankModule,
        UserModule,
        FormsModule,
        MatRadioModule,
        FiPageHeaderModule,
        MatButtonModule,
        SelectSearchModule,
        MatCardModule,
    ],
    declarations: [FiAppearanceListViewViewComponent, FiAppearanceListViewEditComponent],
    exports: [FiAppearanceListViewViewComponent, FiAppearanceListViewEditComponent],
})
export class FiAppearanceListViewModule {}
